module.exports = __webpack_public_path__ + "static/media/freelancer-highlight-1.895bb270.webp";